
var url_domain = window.location.host;
var config_url = '';
var config_url2 = '';
if (url_domain.includes('localhost:80')) {

    config_url = 'https://apicitas.chamirides.com/api/1.0';
    config_url2 = 'https://api.chamirides.com/api/1.0';


// config_url = 'http://127.0.0.1:3333/api/1.0';

} else if (url_domain == 'citas.chamirides.com') {
    config_url = 'https://apicitas.chamirides.com/api/1.0';
    config_url2 = 'https://api.chamirides.com/api/1.0';
}
else if (url_domain == 'citastest.chamirides.com') {
    config_url = 'https://apicitastest.chamirides.com/api/1.0';
    config_url2 = 'https://apitest.chamirides.com/api/1.0';

}
console.log('Backend Conected: ' + config_url)
export const apiPath = config_url;
export const apiPath2 = config_url2;


